import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { MatchReportsDetailsQuery } from '../types';

/**
 * typeguard for MatchReportsDetailsQuery
 * @param MatchReportsDetailsQuery object passed to transformer
 */
export const isValidMatchReportsDetails = (obj: MatchReportsDetailsQuery): boolean => Boolean(obj?.data?.getReportDetails && !isEmptyObject(obj.data.getReportDetails));
